import { createContext, useContext } from "react";
import type { Address, EIP1193Provider } from "viem";

export type WalletSessionStatus =
  | "connected"
  | "disconnected"
  | "connecting"
  | "reconnecting";

export type WalletSession = {
  account?: Address;
  chainId?: number;
  configured: boolean;
  provider?: EIP1193Provider;
  status: WalletSessionStatus;
  openAccount: () => Promise<void>;
  openConnect: () => Promise<void>;
  switchToTargetNetwork: () => Promise<void>;
};

export const WalletSessionContext = createContext<WalletSession | undefined>(
  undefined,
);

export function useWalletSession() {
  const session = useContext(WalletSessionContext);
  if (!session) {
    throw new Error("useWalletSession must be used inside AppKitProvider.");
  }
  return session;
}
